import { render, staticRenderFns } from "./MemoVerification.vue?vue&type=template&id=1278b890"
import script from "./MemoVerification.vue?vue&type=script&lang=js"
export * from "./MemoVerification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports